import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { Lists } from '../../../types/items';

export const getListsRequest = action(
  'GET_LISTS_REQUEST',
  withoutPayload,
);
export const getListsSuccess = action(
  'GET_LISTS_SUCCESS',
  withPayload<Lists>(),
);
export const getListsFail = action(
  'GET_LISTS_FAIL',
  withoutPayload,
);

export const setHoveredItemId = action(
  'SET_HOVERED_ITEM_ID',
  withPayload<number>(),
);
